import { FILE, USER_DOCUMENTS_FORMAT } from "@/shared/constants/FileConstants";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { ListCategory } from "@/shared/models/ListCategory";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import Vuetify from "vuetify";
import { DocumentDTO } from "@/modules/Document/models/DocumentDTO";
import { LOAD_DOCUMENT_CONSTANT } from "@/modules/WebViews/LoadDocument/constants/LoadDocumentConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { Http } from "@status/codes";
import { DocumentService } from "@/modules/Document/services/DocumentService";

Vue.use(Vuetify);
@Component({
  name: "AddFileModal",
  components: {
    ModalTemplate
  }
})
export default class AddFileModal extends Vue {
  @Inject() documentService!: DocumentService;

  @Prop({ default: [] }) categories!: ListCategory[];
  @Prop({ default: false }) isToEdit!: boolean;
  @Prop({ default: false }) loadWithoutCategory!: boolean;
  @Prop() document!: DocumentDTO;
  @Prop({
    default: () => {
      return {};
    }
  })
  categoryDefault!: ListCategory;
  @Prop({ default: "" }) subCategoryDefault!: string;
  @Prop({ default: false }) viewIntelliticks!: boolean;

  confirmUploadDialog = false;
  fileName = "";
  fileType = "";
  selectedFile: File = {} as File;
  category: ListCategory = {} as ListCategory;
  subCategory = "";
  subcategories: string[] = [];
  isValid = false;
  resetFileInput = 0;
  showDefaultFields = true;
  requiredField = FORM_VALIDATORS.REQUIRED_FIELD;
  requiredObject = FORM_VALIDATORS.REQUIRED_OBJECT;

  TITLE = FILE.LABEL.UPLOAD_DOCUMENT;
  EDIT_TITLE = FILE.LABEL.EDIT_DOCUMENT;
  confirmationText = FILE.LABEL.UPLOAD_CONFIRMATION_TEXT;
  confirmationTitle = FILE.LABEL.UPLOAD_CONFIRMATION_TITLE;
  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  btnClassPrimary = STYLE_CLASSES.PRIMARY_BTN;
  btnClassSecondary = STYLE_CLASSES.SECONDARY_BTN;

  RENAME = FILE.LABEL.RENAME;
  RENAME_HINT = FILE.HINT.RENAME;
  DOCUMENT_INPUT = FILE.LABEL.DOCUMENT_INPUT;
  SELECT_DOCUMENT_LABEL = FILE.LABEL.FORMAT_UPLOAD_FILE;
  CATEGORY_LABEL = FILE.LABEL.CATEGORY;
  SUB_CATEGORY_LABEL = FILE.LABEL.SUB_CATEGORY;
  CANCEL_BTN = FILE.BUTTON.CANCEL;
  UPLOAD_BTN = FILE.BUTTON.UPLOAD;
  UPDATE_BTN = FILE.BUTTON.UPDATE;
  DELETE_BTN = FILE.BUTTON.DELETE;
  DOCUMENT_FORMAT = USER_DOCUMENTS_FORMAT;

  mounted() {
    if (this.categoryDefault && this.subCategoryDefault) {
      this.showDefaultFields = false;
      this.category = this.categoryDefault;
      this.selectedCategory();
      this.subCategory = this.subCategoryDefault;
    }

    if (this.isToEdit) {
      this.preloadForm();
    }
  }
  selectedCategory() {
    this.subcategories = this.category.subcategories;
  }

  async getFileUploaded(file?: File) {
    if (this.viewIntelliticks) {
      const limitSize = await this.documentService.getlimitSize();
      if (
        limitSize.code === Http.Found &&
        file!.size > Number(limitSize.data)
      ) {
        (this.$refs.fileInput as Vue & { reset: () => void }).reset();

        Snackbar.popInfo(
          LOAD_DOCUMENT_CONSTANT.PARENT_MESAGGES.LIMIT_SIZE +
            (Number(limitSize.data!) / 1000000).toString() +
            " MB"
        );
        return;
      }
    }

    if (file) {
      this.splitName(file.name);
      this.selectedFile = file;
    } else {
      this.clearDocumentName();
    }
  }

  splitName(fullName: string) {
    const array = fullName.split(".");
    const last = array.pop();

    if (last) {
      this.fileType = last.toLocaleLowerCase();
      this.fileName = array.join(".");
    } else {
      this.clearDocumentName();
    }
  }

  clearDocumentName() {
    this.fileName = "";
    this.fileType = "";
  }

  clearFields() {
    this.selectedFile = {} as File;
    this.category = {} as ListCategory;
    this.subCategory = "";
    this.isValid = false;
    this.resetFileInput = 1 - this.resetFileInput;
    this.clearDocumentName();
  }

  cancelUpload() {
    this.$emit(FILE.EVENT.CANCEL);
    this.clearFields();
  }

  uploadDocument() {
    this.confirmUploadDialog = true;
  }

  deleteFile() {
    this.$emit(FILE.EVENT.DELETE);
    this.clearFields();
    this.confirmUploadDialog = false;
  }

  async handleModalAccept() {
    if (this.isToEdit) {
      this.$emit(
        FILE.EVENT.UPLOAD,
        this.document._key,
        this.category,
        this.subCategory
      );
    } else {
      this.$emit(
        FILE.EVENT.UPLOAD,
        this.selectedFile,
        this.fileName,
        this.fileType,
        this.category,
        this.subCategory
      );
    }

    this.clearFields();
    this.confirmUploadDialog = false;
  }

  handleModalCancel() {
    this.confirmUploadDialog = false;
  }

  preloadForm() {
    this.fileName = this.document.fileName;
    this.category = this.categories.find(
      item => item.name === this.document.category.name
    ) as ListCategory;
    this.subcategories = this.category.subcategories;
    this.subCategory = this.document.category.subCategory;
  }
}
